/**
 * @copyright Copyright (c) 2020, KNE GmbH.
 *
 * @author Jan Duwe <jan.duwe@kne.de>
 *
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License, version 3,
 * as published by the Free Software Foundation.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License, version 3,
 * along with this program.  If not, see <http://www.gnu.org/licenses/>
 *
 */

import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

import { Module } from "vuex";
import { IRootState } from '../../model/RootState';
import { ICoreState } from '../../model/CoreState'

export const state: ICoreState = {
    isLoading: 0
}

const namespaced = true;

export const core: Module<ICoreState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced,
    state,
}
